import React, { ChangeEvent, useState } from 'react'
import { Form } from 'react-bootstrap'
import classNames from 'classnames'
import { WidgetProps } from '@rjsf/utils'
import { ExtendedCustomWidgetProps } from '../FormCitation/FormCitation'

export const CustomTextWidget: React.FC<WidgetProps> = (props) => {
  const [error, setError] = useState('')
  const { onChange, value, disabled } = props
  const { isEditing, fieldContainerClass, citationButton, pattern, customPlaceholder, setValidatorSucceeded } = props.options as ExtendedCustomWidgetProps

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    onChange(newValue)

    if (newValue) {
      const regExp = new RegExp(pattern, 'i')
      if (!regExp.test(newValue)) {
        setError(`Format: ${customPlaceholder}`)
        setValidatorSucceeded(false)
      } else {
        setError('')
        setValidatorSucceeded(true)
      }
    } else {
      setError('')
      setValidatorSucceeded(true)
    }
  }

  return (
    <div>
      <div className={fieldContainerClass}>
        <Form.Control
          type='text'
          value={value || ''}
          onChange={handleChange}
          className={classNames('form-control', { 'disabled-contact-information-field border-0': disabled })}
          disabled={disabled}
          pattern={pattern}
          placeholder={value === null && !isEditing ? 'No relevant information detected' : customPlaceholder}
        />
        {!isEditing && value ? citationButton : null}
      </div>
      {error && <Form.Text className='text-danger d-block'>{error}</Form.Text>}
    </div>
  )
}
